export default from './generic-input'
